module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bs4"
  }, [(_vm.data !== null) ? _c('div', {
    staticClass: "trustpilot-service-main-widget t container px-0 d-customize-none modal-background"
  }, [_c('div', {
    staticClass: "avgStars"
  }, [_vm._v(_vm._s(_vm.data.average_score)), _c('div', {
    staticClass: "star_image"
  }, [_vm._l((5), function(n) {
    return [(n > _vm.data.average_score) ? _c('img', {
      attrs: {
        "src": "/img/trustpilot/star.svg"
      }
    }) : _c('img', {
      attrs: {
        "src": "/img/trustpilot/star_filled.svg"
      }
    })]
  })], 2), _c('p', [_vm._v(_vm._s(_vm.__('Based on')) + " " + _vm._s(_vm.data.total_reviews) + " " + _vm._s(_vm.__('reviews')))])]), _c('div', {
    staticClass: "review_detail"
  }, [_c('div', {
    staticClass: "filter_by_rating"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "order": "100",
      "margin-bottom": "0px"
    }
  }, [_vm._v(_vm._s(_vm.__('Filter by Rating')))]), _vm._l((5), function(n) {
    return _c('b', {
      staticClass: "stars_summary",
      style: ({
        order: _vm.index
      })
    }, [_c('span', {
      staticStyle: {
        "width": "45px"
      },
      on: {
        "click": function($event) {
          _vm.star = n
        }
      }
    }, [_vm._v(_vm._s(n) + " " + _vm._s(_vm.__('Star')))]), _c('div', {
      staticClass: "progress_bar",
      on: {
        "click": function($event) {
          _vm.star = n
        }
      }
    }, [(_vm.data.stars_reviews[n]) ? _c('div', {
      staticClass: "progress",
      style: ({
        width: (_vm.data.stars_reviews[n]) * 100 / _vm.data.total_reviews + '%'
      })
    }) : _c('div', {
      staticClass: "progress",
      style: ({
        width: '0%'
      })
    })]), _c('span', {
      staticClass: "count",
      on: {
        "click": function($event) {
          _vm.star = n
        }
      }
    }, [_vm._v("(" + _vm._s(_vm.data.stars_reviews[n] || 0) + ")")])])
  })], 2)]), _c('div', {
    staticClass: "reviews"
  }, [_c('hr'), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideLanguage),
      expression: "hideLanguage"
    }],
    staticClass: "lang",
    on: {
      "click": function($event) {
        _vm.show.languages = 1
      }
    }
  }, [_vm._v(_vm._s(_vm.__('Language'))), _c('img', {
    staticClass: "options_arrow",
    attrs: {
      "src": "/img/trustpilot/chevron_down.svg"
    }
  }), (_vm.show.languages) ? _c('div', {
    staticClass: "option_list"
  }, _vm._l((_vm.languages), function(lang, label) {
    return _c('div', {
      class: {
        selected: _vm.language == label
      },
      attrs: {
        "value": label
      },
      on: {
        "click": function($event) {
          _vm.language = label
        }
      }
    }, [_vm._v(_vm._s(lang) + " (" + _vm._s(_vm.data.language_reviews[label] || 0) + ")")])
  })) : _vm._e()]), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideSorting),
      expression: "hideSorting"
    }],
    staticClass: "sort_by",
    on: {
      "click": function($event) {
        _vm.show.sorting = 1
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.__('Sort By:')) + " " + _vm._s(_vm.__(_vm.sortings[_vm.sorting])))]), _c('img', {
    staticClass: "options_arrow",
    attrs: {
      "src": "/img/trustpilot/chevron_down.svg"
    }
  }), (_vm.show.sorting) ? _c('div', {
    staticClass: "option_list"
  }, _vm._l((_vm.sortings), function(sort, label) {
    return _c('div', {
      class: {
        selected: _vm.sorting == label
      },
      attrs: {
        "value": label
      },
      on: {
        "click": function($event) {
          _vm.sorting = label
        }
      }
    }, [_vm._v(_vm._s(_vm.__(sort)))])
  })) : _vm._e()])]), _c('hr'), (_vm.language != '' || _vm.star != '') ? _c('div', {
    staticClass: "filter_row"
  }, [_c('p', {
    staticClass: "filter_label"
  }, [_vm._v(_vm._s(_vm.__('Active Filters:')))]), (_vm.language != '') ? _c('div', {
    staticClass: "active_filters",
    on: {
      "click": function($event) {
        _vm.language = ''
      }
    }
  }, [_vm._v(_vm._s(_vm.languages[_vm.language]))]) : _vm._e(), (_vm.star != '') ? _c('div', {
    staticClass: "active_filters",
    on: {
      "click": function($event) {
        _vm.star = ''
      }
    }
  }, [_vm._v(_vm._s(_vm.star) + " Star")]) : _vm._e(), _c('div', {
    staticClass: "clear_filter",
    on: {
      "click": function($event) {
        _vm.language = '';
        _vm.star = ''
      }
    }
  }, [_vm._v(_vm._s(_vm.__('Clear All')))])]) : _vm._e(), (_vm.data.reviews.length) ? [_vm._l((_vm.data.reviews), function(review) {
    return [_c('div', {
      staticClass: "review"
    }, [_c('div', {
      staticClass: "sidebar"
    }, [_c('div', {
      staticClass: "customer_name"
    }, [_vm._v(_vm._s(review.consumer_name))]), (review.isVerified) ? _c('div', {
      staticClass: "verified"
    }, [_c('img', {
      attrs: {
        "src": "/img/trustpilot/verified_buyer.svg"
      }
    }), _c('span', {
      staticStyle: {
        "position": "relative",
        "top": "-2px"
      }
    }, [_vm._v("Verified Buyer")])]) : _vm._e(), _c('div', {
      staticClass: "review_date"
    }, [_vm._v(_vm._s(_vm.moment(review.createdAt).format('MM/DD/YY')))]), _c('div', {
      staticClass: "product_name"
    })]), _c('div', {
      staticClass: "review_detail_content"
    }, [_vm._l((5), function(n) {
      return [(n > review.stars) ? _c('img', {
        staticClass: "star_image",
        attrs: {
          "src": "/img/trustpilot/star.svg"
        }
      }) : _c('img', {
        staticClass: "star_image",
        attrs: {
          "src": "/img/trustpilot/star_filled.svg"
        }
      })]
    }), _c('div', {
      staticClass: "review_title"
    }, [_vm._v(_vm._s(review.title))]), _c('div', {
      staticClass: "review_content"
    }, [_vm._v(_vm._s(review.text))])], 2)]), _c('hr')]
  }), _c('div', {
    staticClass: "pagination"
  }, [_c('img', {
    attrs: {
      "src": "/img/trustpilot/prev.png"
    },
    on: {
      "click": function($event) {
        _vm.page > 1 ? _vm.page = _vm.page - 1 : false
      }
    }
  }), _vm._l((_vm.data.total_pages), function(n) {
    return _c('div', {
      staticClass: "page",
      class: {
        show: (_vm.data.page - 2 <= n && n <= _vm.data.page + 2) || (_vm.data.page <= 3 && n <= 5) || (_vm.data.page > _vm.data.total_pages - 3 && n > _vm.data.total_pages - 5), active: n == _vm.data.page
      },
      on: {
        "click": function($event) {
          _vm.page = n
        }
      }
    }, [_vm._v(_vm._s(n))])
  }), _c('img', {
    attrs: {
      "src": "/img/trustpilot/next.png"
    },
    on: {
      "click": function($event) {
        _vm.page < _vm.data.total_pages ? _vm.page = _vm.page + 1 : false
      }
    }
  })], 2)] : _c('div', {
    staticClass: "no-review"
  }, [_vm._v(_vm._s(_vm.__('No Review')))])], 2)]) : _c('div', [_vm._v(_vm._s(_vm.__('Loading')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57209a8b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CMSTrustPilotService.vue
// module id = 285
// module chunks = 15